import { render } from "./ButtonEvaluation.vue?vue&type=template&id=58f86891"
import script from "./ButtonEvaluation.vue?vue&type=script&lang=js"
export * from "./ButtonEvaluation.vue?vue&type=script&lang=js"
script.render = render

export default script